export default __webpack_public_path__ + "static/media/patrick ahrens.22818c1c.jpg";